import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import renderHTML from 'react-render-html';
// import SearchBar from '../common/SearchBar';

class SearchNotFound extends Component {
	handleChange(query) {
		browserHistory.push(`/search?q=${query}&type=product`);
	}
	
	render() {
		return (
			<section className="section section-search-results no-results">
				<Helmet>
					<title>{ renderHTML(`Search Results for "${this.props.keyword}" | SentrySafe`) }</title>
				</Helmet>
				<div className="section-content row">
					<div className="col">
						<h1 className="section-title">
							<b>0</b> Results for &ldquo;{ this.props.keyword }&rdquo;
						</h1>
						<p>
							Sorry, we didn&rsquo;t find any matches for <b>{ this.props.keyword }</b>.
							Please modify your search and try again.
						</p>
						{/*<div className="search-bar-container">
							<SearchBar />
						</div>*/}
					</div>
				</div>
			</section>
		);
	}
};

export default branch({
	token: ['token']
}, SearchNotFound);


// WEBPACK FOOTER //
// ./src/pages/notFound/SearchNotFound.js